const KEY_REF = "__referrer__"
export default {
  setReferrer() {
    if (!document.referrer.includes(window.location.origin)) {
      sessionStorage.setItem(KEY_REF, document.referrer)
    }
  },
  getReferrer() {
    return sessionStorage.getItem(KEY_REF)
  },
  getScale() {
    //@ts-ignore
    return window.__scale__ || 1
  },
}
